<template>
  <div class="foot-nav-box">
    <van-tabbar v-model="active" inactive-color="#8A8A8A" active-color="#8A3E2F">
      <van-tabbar-item replace :to="{name: 'home'}">
        <span>奖励</span>
        <img slot="icon" slot-scope="props" :src="props.active ? icon.active : icon.normal">
      </van-tabbar-item>
      <van-tabbar-item replace :to="{name: 'myUserHome'}">
        <span>我的</span>
        <img slot="icon" slot-scope="props" :src="props.active ? iconUser.active : iconUser.normal">
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      icon: {
        normal: require("../../assets/images/jiangli1.png"),
        active: require("../../assets/images/jiangli2.png")
      },
      iconUser: {
        normal: require("../../assets/images/iconwodeweixuanzhong.png"),
        active: require("../../assets/images/iconwodexuanzhong.png")
      }
    };
  },
  props: {
    tabIndex: {
      type: Number,
      default: 1
    }
  },
  watch: {
    tabIndex: {
      handler: function(val, oldval) {
        this.active = this.tabIndex || 0;
      },
      deep: true
    }
  },
  created () {
    this.active = this.tabIndex || 0;
  }
};
</script>

<style lang="less">
.foot-nav-box {
  position: fixed;
  width: 100%;
  bottom: 0;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.08);
}
</style>
